/** What the Data address can say. The route checks it before the screen is loaded, so it lives apart from `model.ts`. */
export type DataTab = "sources" | "connect" | "changes";
export const DATA_TABS: DataTab[] = ["sources", "connect", "changes"];
export type DataSearch = { view?: DataTab; source?: string };
